import { useEffect, useRef } from "react";

/**
 * useReveal - attaches IntersectionObserver to a container to reveal
 * children with the ".reveal" class by adding ".is-visible".
 */
export default function useReveal(options = {}) {
  const containerRef = useRef(null);

  useEffect(() => {
    const root = containerRef.current || document;
    const items = root.querySelectorAll(".reveal");
    if (!items.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px", ...options }
    );

    items.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [options]);

  return containerRef;
}
